module.exports = __webpack_public_path__ + "static/media/illustration.211c7732.svg";